import { Skeleton, TableCell, TableRow } from '@mui/material';

export interface DataTableSkeletonProps {
  length: number;
  rows?: number;
}

export default function DataTableSkeleton({ length, rows = 5 }: DataTableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={`skeleton-row-${rowIndex}`} data-testid='dataTableSkeleton-render-test'>
          {Array.from({ length }).map((_, cellIndex) => (
            <TableCell key={`skeleton-cell-${rowIndex}-${cellIndex}`} sx={{ borderBottom: `none` }}>
              <Skeleton sx={{ flex: 1, height: 40, borderRadius: 0.3 }} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}